import Vue from 'vue/dist/vue.esm'
import '../lib/csrf-token'

import TerminateResidency from '../components/account/terminate-residency'
import DeleteAccount from '../components/account/delete-account'

document.addEventListener('DOMContentLoaded', () => {

  new Vue({
    el: '#app',
    components: {
      TerminateResidency,
      DeleteAccount
    }
  })
})